import React from "react";
import { Row, Col, Typography } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import { green } from "@ant-design/colors";

const { Title, Text, Link } = Typography;

const SignUpFormComplete = () => {
  return (
    <Row justify="center">
      <Col span={18} style={{ textAlign: "center" }}>
        <CheckCircleFilled style={{ color: green.primary, fontSize: 48, marginBottom: 16, marginTop: 16 }} />

        <Title level={2}>Success</Title>

        <Text>
          Thank you for signing up. Your information is being reviewed. An activation email will be sent to your
          registered email shortly.
        </Text>

        {/* <p style={{ marginTop: 24 }}>
          <Link href="/">Back to Home</Link>
        </p> */}
      </Col>
    </Row>
  );
};

export default SignUpFormComplete;
